module.exports = __webpack_public_path__ + "media/images/thumbs/biology/m_animation_transcription_13-44181b12831e3bee60dfd1d89e645046.jpg";